import React from 'react';
import { MediaProvider } from './src/context/MediaProvider';
import { RecaptchaProvider } from './src/components/Shared/RecaptchaProvider';
import { initializeClientMonitoring } from './src/utils/monitoring';
import { preloadCustomComponentsForPath } from './src/components/ComponentMap';
import './src/styles/global.css';

export const onClientEntry = () => {
  const startMonitoring = () => {
    void initializeClientMonitoring();
  };

  if (typeof window !== 'undefined' && typeof window.requestIdleCallback === 'function') {
    window.requestIdleCallback(startMonitoring);
  } else {
    setTimeout(startMonitoring, 1);
  }

  return preloadCustomComponentsForPath(window.location.pathname);
};

export const onRouteUpdate = ({ location }) => {
  if (process.env.NODE_ENV !== 'production' || typeof window.gtag !== 'function') {
    return;
  }

  const sendPageView = () => {
    window.gtag('event', 'page_view', {
      page_path: `${location?.pathname || ''}${location?.search || ''}${location?.hash || ''}`,
    });
  };

  if ('requestAnimationFrame' in window) {
    window.requestAnimationFrame(() => window.requestAnimationFrame(sendPageView));
    return;
  }

  window.setTimeout(sendPageView, 32);
};

export const wrapRootElement = ({ element }) => (
  <MediaProvider>
    <RecaptchaProvider>{element}</RecaptchaProvider>
  </MediaProvider>
);
